import * as React from 'react';
import { SVGProps, Ref, forwardRef } from 'react';
const SvgGenericImage = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M.5 1.5a1 1 0 0 1 1-1h9.586a1 1 0 0 1 .707.293l3.414 3.414a1 1 0 0 1 .293.707V14.5a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-13Z"
      stroke="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgGenericImage);
export default ForwardRef;
